var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 19.7787C21.3333 20.6373 20.736 21.3333 20 21.3333H4L14.088 12.244C14.416 11.9173 15.0107 11.9187 15.332 12.2427L21.3333 18.2133V19.7787ZM6.66667 5.33333C7.77067 5.33333 8.66667 6.22933 8.66667 7.33333C8.66667 8.43733 7.77067 9.33333 6.66667 9.33333C5.56267 9.33333 4.66667 8.43733 4.66667 7.33333C4.66667 6.22933 5.56267 5.33333 6.66667 5.33333ZM20 0H4C1.79467 0 0 1.79467 0 4V20C0 22.2053 1.79467 24 4 24H20C22.2053 24 24 22.2053 24 20V4C24 1.79467 22.2053 0 20 0Z",
    fill: "#F4F3F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/iconAvatar.afd8943107a66fc31cda198919c5bd7b.svg";
export { ForwardRef as ReactComponent };